module.exports = __webpack_public_path__ + "img/bloom_dark_brown_ba_detail_rsh.8136b72e.jpg";